<div class="loader" align="center" *ngIf="loading">
    <div>
      <!-- -->
    </div>
  </div>
<section class="card"  [ngStyle]="{'opacity':loading === true ? 0.5 : 1}">
    <div class="card-header">
        <span class="cat__core__title">
            <strong>UPSI Details</strong>
        </span>
        <span style="float: right">
            <button type="button" class="btn btn-sm btn-default mr-tN" (click)="back()">
                <i class="fa fa-chevron-circle-left"></i>&nbsp;Back</button>
        </span>
    </div>
    <div class="card-block">
        <div class="row">
            <div class="col-md-12">
                <form [formGroup]="sharerForm" class="well" NoValidate>

                    <div class="modal-body">
                        <div class="row" *ngIf="!isUPSILiteActive">
                            <div class="col-lg-2">
                                <label class="form-control-label">UPSI Sharer:</label>
                                <span _ngcontent-c2="" style="color: red;">*</span>
                            </div>
                            <div class="col-lg-5">
                               
                                <div class="form-group" >
                                    <div class="md-radio">
                                        <input id="govevaUser" type="radio"
                                            [formControl]="sharerForm.controls['sharerType']" name="sharerType"
                                            class="col-lg-2" style="padding:6px;float:none;width:auto;" value="govevaUser"
                                            (click)="sharerListModal('govevaUser')">
                                        <label for="govevaUser">Select DigiCompany User</label>
                                    </div>
                                    <div class="md-radio">
                                        <input id="upsiSharer" type="radio"
                                            [formControl]="sharerForm.controls['sharerType']" name="sharerType"
                                            class="col-lg-2" style="padding:6px;float:none;width:auto;" value="nonGovevaUser"
                                            (click)="sharerListModal('nonGovevaUser')">
                                        <label for="upsiSharer">UPSI Sharer</label>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-1">
                                <button class="btn btn-sm btn-primary pull-left" [appHasPermission]="{'Url': '/uspiSharer/add', 'method':'post', 'menu': 'UPSI Sharer'}"  (click)="userListModal($event)">Add New
                                    UPSI Sharer</button>
                             

                            </div>
                        </div>
                        <div class="row" *ngIf="!isUPSILiteActive">
                            <div class="col-lg-2">
                                <label class="form-control-label">UPSI Recipients:</label>
                                <span _ngcontent-c2="" style="color: red;">*</span>
                            </div>
                            <div class="col-lg-5">
                                <div class="form-group">
                                    <div class="md-radio">
                                        <input id="recipientSelectUnified" type="radio"
                                            [formControl]="sharerForm.controls['receipientType']" name="receipientType"
                                            class="col-lg-2" style="padding:6px;float:none;width:auto;" value="both"
                                            (click)="recipientListModal('both')">
                                        <label for="recipientSelectUnified">Select Recipients</label>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-1">
                                <button class="btn btn-sm btn-primary pull-left"   [appHasPermission]="{'Url': '/uspiRecipient/add', 'method':'post', 'menu': 'UPSI Recipient'}"    
                                    (click)="recipientUserListModal($event)">Add New UPSI Recipients</button>
                            </div>
                        </div>
                        <div class="row" *ngIf="isUPSILiteActive">
                            <div class="col-lg-2">
                                <label class="form-control-label">UPSI Sharer:</label>
                                <span _ngcontent-c2="" style="color: red;">*</span>
                            </div>
                            <div class="col-lg-5">
                               
                                <div class="form-group" >
                                    <div class="md-radio">
                                        <input id="govevaUser" type="radio"
                                            [formControl]="sharerForm.controls['sharerType']" name="sharerType"
                                            class="col-lg-2" style="padding:6px;float:none;width:auto;" value="govevaUser"
                                            (click)="sharerListModal('govevaUser')">
                                        <label for="govevaUser">Select UPSI Sharer</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row" *ngIf="isUPSILiteActive">
                            <div class="col-lg-2">
                                <label class="form-control-label">UPSI Recipients:</label>
                                <span _ngcontent-c2="" style="color: red;">*</span>
                            </div>
                            <div class="col-lg-5">
                                <div class="form-group">
                                    <div class="md-radio">
                                        <input id="recipientSelectUnifiedLite" type="radio"
                                            [formControl]="sharerForm.controls['receipientType']" name="receipientType"
                                            class="col-lg-2" style="padding:6px;float:none;width:auto;" value="both"
                                            (click)="recipientListModal('both')">
                                        <label for="recipientSelectUnifiedLite">Select Recipients</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row" style="margin-bottom: 10px">
                            <div class="col-lg-2"> </div>
                            <div class="col-lg-2" *ngIf="sharerName">
                                Selected Sharer :<li><b>{{sharerName}}</b></li>
                            </div>
                          
                            <div class="col-lg-2" *ngIf="RecipientNameArray">
                                Selected Recipients :<li *ngFor="let user of RecipientNameArray">
                                    <b>{{ (user.Name)?user.Name:user.FirstName + ' ' + user.LastName}}</b></li>
                            </div>
                        </div>
                        <div class="row" style="margin-bottom: 10px">
                            <div class="col-lg-2">
                                <label class="form-control-label">Nature of UPSI:</label>
                                <span style="color: red;">*</span>
                            </div>
                            <div class="col-lg-3">

                                <select (change)="changeNature()" id="NatureId"
                                    [formControl]="sharerForm.controls['NatureofUPSI']" class="form-control">
                                    <option value='' [selected]="true">Select</option>
                                    <option *ngFor="let item of ItemList" value="{{item._id}}">{{item.Item}}</option>
                                    <option value='Other'>Other</option>
                                </select>
                                <div *ngIf="sharerForm.controls['NatureofUPSI'].hasError('required') && sharerForm.controls['NatureofUPSI'].touched"
                                    class="form-control-error-custom">
                                    Nature of UPSI is required.
                                </div>

                            </div>
                            <div class="col-lg-1">
                                <!-- <button type="button" class="btn btn-sm btn-primary pull-right" (click)="addModel()">Add
                                    New </button> -->
                            </div>
                            <div class="col-lg-2">
                                <label class="form-control-label">
                                    Brief details of UPSI shared:
                                    <span style="color: red;">*</span>
                                </label>
                            </div>
                            <div class="col-lg-4">
                                <textarea [formControl]="sharerForm.controls['typeOfShared']" class="form-control"
                                    >{{sharerForm.controls['typeOfShared']}}</textarea>
                                <div *ngIf="sharerForm.controls['typeOfShared'].hasError('required') && sharerForm.controls['typeOfShared'].touched"
                                    class="form-control-error-custom">
                                    Brief details of UPSI shared is required.
                                </div>
                                <div class="form-control-error-custom" *ngIf="sharerForm.controls['typeOfShared'].value.length > 500">
                                    Maximum 500 Characters Limit Crossed !
                                </div>
                                <div *ngIf="sharerForm.get('typeOfShared')?.errors?.['inappropriateLanguage'] && sharerForm.get('typeOfShared')?.touched"
                                    class="form-control-error-custom">
                                    {{ sharerForm.get('typeOfShared')?.errors?.['inappropriateLanguage']?.message }}
                                </div>
                            </div>

                        </div>
                        <div class="row" *ngIf="othernature">
                            <div class="col-lg-2">
                                <label class="form-control-label">Other Nature of UPSI:</label>
                                <span style="color: red;">*</span>
                            </div>
                            <div class="col-lg-3">

                                <input (change)="othernaturemethod()"
                                    [formControl]="sharerForm.controls['OtherNatureOfUPSI']" class="form-control">


                                <div class="form-control-error-custom" *ngIf="OtherNatureOfUPSIValid">
                                    Other Nature of UPSI is required.
                                </div>
                                <div class="form-control-error-custom" *ngIf="sharerForm.controls['OtherNatureOfUPSI'].value.length > 100">
                                    Maximum 100 Characters Limit Crossed !
                                </div>
                            </div>


                        </div>
                        <div class="panel-group panel panel-primary panel-highlighted"     *ngIf='!isBulkData && EmailWithAttachment && EmailUpsiAdd'>
                            <h6 style="text-align: center"><b>For Sharing Email through DigiCompany UPSI Software</b> </h6>
                            <div class="row" style="margin-top: 5px;">
                                <div class="col-md-2">
                                    <label class="form-control-label" for="l0">Email Subject: </label>
                                </div>
                                <div class="col-md-4">
                                    <div class="form-group">

                                        <textarea [formControl]="sharerForm.controls['EmailSubject']"
                                            class="form-control IsDisableEmail" (change)="EmailsCheck($event)">
                                          </textarea>
                                    </div>
                                    <div class="form-control-error-custom" *ngIf="sharerForm.controls['EmailSubject'].value.length > 250">
                                        Maximum 250 Characters Limit Crossed !
                                    </div>
                                </div>
                                <div class="col-md-2" >
                                    <label class="form-control-label" for="l0">Attachment for Email:
                                    </label>
                                </div>
                                <div class="col-md-4" >
                                    <div class="form-group">
                                        <label class="input-group">
                                            <input data-toggle="tooltip" type="text"
                                            [value]="(fileNameArray.length+listOfFiles.length) > 0 ? listOfFiles.length + fileNameArray.length  + ' Files Selected':' File Not Available'"
                                                class="form-control" [disabled]="true">
        
                                            <!-- <span *ngIf="agenda.AgendaGenerationPdf && agenda.AgendaGenerationPdf.length > 0 && agenda.AgendaGenerationPdf[0].IsAvailable" (click)="downloadDoc(agenda.AgendaGenerationPdf[0].DocumentManagementID)"
                                                        class="input-group-addon default">
                                                        <i class="fa fa-download"></i>
                                                    </span> -->
                                            <span class="input-group-addon warning"
                                                (click)="initiateUploadEmailDocument($event)"
                                               >
                                                <i class="fa fa-upload"></i>
                                            </span>
        
                                        </label>
                                        <!-- <input name="Attachment" class='form-control IsDisableEmail' type="file"
                                            (change)="fileChangedEmail($event);EmailsCheck($event);" accept=".xlsx, .xls, .csv, .jpg, .jpeg, .png, .doc, .docx, .txt, .pdf, .ppt, .mp4,.pptx">
                                        <span style="color: red" *ngIf="!fileExtension">Please upload valid file format.</span> -->
                                    </div>
                                </div>

                                <!-- <div class="col-lg-2" *ngIf="DocumentFileDoc">
                                    <label class="form-control-label">Attachment for Email:</label>
                                </div>
                                <div class="col-lg-4" *ngIf="DocumentFileDoc">
                                    <div class="form-group">

                                        <a class="btn btn-sm btn-default IsDisableEmail"><span
                                                (click)="downloadFileEmail()">{{FileNameO }}</span>&nbsp;<span
                                                (click)="downloadFileEmail()" style="margin-left: 10px"><i
                                                    class="fa fa-download"></i></span></a>
                                    </div>

                                </div> -->





                            </div>
                            <div class="row" style="margin-top: 5px;">
                                <div class="col-md-2">
                                    <label class="form-control-label" for="l0">Email Text: </label>
                                </div>
                                <div class="col-md-10">
                                    <div class="form-group">

                                        <textarea [formControl]="sharerForm.controls['EmailText']"
                                            (change)="EmailsCheck($event)" class="form-control IsDisableEmail" rows="4">
                                      </textarea>
                                    </div>
                                    <div class="form-control-error-custom" *ngIf="sharerForm.controls['EmailText'].value.length > 1000">
                                        Maximum 1000 Characters Limit Crossed !
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row" style="margin-bottom: 10px">
                            <div class="col-lg-2">
                                <label class="form-control-label">Purpose for Sharing:</label>
                                <span style="color: red;">*</span>
                            </div>
                            <div class="col-lg-4">
                                <textarea [formControl]="sharerForm.controls['purposeForSharing']" class="form-control">
                                    {{sharerForm.controls['purposeForSharing']}}</textarea>
                                <div *ngIf="sharerForm.controls['purposeForSharing'].hasError('required') && sharerForm.controls['purposeForSharing'].touched"
                                    class="form-control-error-custom">
                                    Purpose for Sharing is required.
                                </div>
                                <div class="form-control-error-custom" *ngIf="sharerForm.controls['purposeForSharing'].value.length > 500">
                                    Maximum 500 Characters Limit Crossed !
                                </div>
                                <div *ngIf="sharerForm.get('purposeForSharing')?.errors?.['inappropriateLanguage'] && sharerForm.get('purposeForSharing')?.touched"
                                    class="form-control-error-custom">
                                    {{ sharerForm.get('purposeForSharing')?.errors?.['inappropriateLanguage']?.message }}
                                </div>
                            </div>
                            <div class="col-lg-2">
                                <label class="form-control-label">Manner/mode of sharing:<span
                                        style="color: red;">*</span></label>

                            </div>
                            <div class="col-lg-4">
                                <textarea [formControl]="sharerForm.controls['modeOfSharing']" class="form-control">
                                    {{sharerForm.controls['modeOfSharing']}}</textarea>
                                <div *ngIf="sharerForm.controls['modeOfSharing'].hasError('required') && sharerForm.controls['modeOfSharing'].touched"
                                    class="form-control-error-custom">
                                    Manner/mode of sharing is required.
                                </div>
                                <div class="form-control-error-custom" *ngIf="sharerForm.controls['modeOfSharing'].value.length > 500">
                                    Maximum 500 Characters Limit Crossed !
                                </div>
                                <div *ngIf="sharerForm.get('modeOfSharing')?.errors?.['inappropriateLanguage'] && sharerForm.get('modeOfSharing')?.touched"
                                    class="form-control-error-custom">
                                    {{ sharerForm.get('modeOfSharing')?.errors?.['inappropriateLanguage']?.message }}
                                </div>
                            </div>

                        </div>
                        <div class="row IsDisable">
                            <div class="col-lg-2">
                                <label class="form-control-label">Shared Date:</label>
                                <span style="color: red;">*</span>
                            </div>
                            <div class="col-lg-4">
                                <div class="input-group" (click)="$event.stopPropagation();">
                                    
                                    <input onkeydown="return false" class="form-control IsDisable"
                                        [formControl]="sharerForm.controls['sharedDate']" placeholder="dd-mm-yyyy"
                                        name="sharerDate" ngbDatepicker #a="ngbDatepicker" 
                                        (ngModelChange)="setPublicDate($event)" (click)="a.toggle();">
                                    <button class="input-group-addon IsDisable" (click)="a.toggle();" type="button">
                                        <span class="fa fa-calendar"></span>
                                    </button>

                                </div>
                                <div *ngIf="sharerForm.controls['sharedDate'].hasError('required') && sharerForm.controls['sharedDate'].touched"
                                    class="form-control-error-custom">
                                    Shared Date is required.
                                </div>
                            </div>
                            <div class="col-lg-2">
                                <label class="form-control-label">Shared Time:</label>
                                <span style="color: red;">*</span>
                            </div>
                            <div class="col-lg-4">
                                <div class="form-group">
                                    <label class="input-group" (focusout)="timeShared($event)">
                                        <input onkeydown="return false" type="text" class=" IsDisable form-control timepicker-init"
                                            [formControl]="sharerForm.controls['sharedTime']">
                                        <span class="input-group-addon">
                                            <i class="icmn-clock"></i>
                                        </span>
                                    </label>
                                    <div *ngIf="sharerForm.controls['sharedTime'].hasError('required') && sharerForm.controls['sharedTime'].touched"
                                        class="form-control-error-custom">
                                        Shared Date is required.
                                    </div>
                                </div>
                            </div>
                        </div>

                        <h6 style="text-align: center" *ngIf="textMsg"><b>Shared Date and Shared Time will be email date
                                and time</b></h6>

                        <div class="row">
                            <div class="col-lg-2">
                                <label class="form-control-label">Date of initiation of UPSI:</label>
                            </div>
                            <div class="col-lg-4">
                                <div class="input-group" (click)="$event.stopPropagation();">
                                    <input class="form-control" [formControl]="sharerForm.controls['DateOfInitiation']"
                                        placeholder="dd-mm-yyyy" ngbDatepicker #u="ngbDatepicker" (click)="u.toggle();">
                                    <button class="input-group-addon" (click)="u.toggle();" type="button">
                                        <span class="fa fa-calendar"></span>
                                    </button>
                                </div>
                            </div>

                            <div class="col-lg-2">
                                <label class="form-control-label">Persons in possession of UPSI:</label>

                            </div>
                            <div class="col-lg-4">
                                <textarea [formControl]="sharerForm.controls['possessionOfUPSI']" class="form-control">
                                    {{sharerForm.controls['possessionOfUPSI']}}</textarea>
                                <div class="form-control-error-custom" *ngIf="sharerForm.controls['possessionOfUPSI'].value.length > 2000">
                                        Maximum 2000 Characters Limit Crossed !
                                </div>
                            </div>

                        </div>
                        <div class="panel-group panel panel-primary1 panel-highlighted">
                            <h6 style="text-align: center"><b>When UPSI is made Public / UPSI Not Applicable</b></h6>
                            <!-- <div class="row">
                                <div class="col-lg-3"></div>
                                <div class="col-lg-3">
                                    <div class="form-group">
                                        <div class="md-radio">
                                            <input id="publicYes" type="radio"
                                                [formControl]="sharerForm.controls['PublicStatus']" class="col-lg-2"
                                                style="padding:6px;" value="UPSI Made Public">
                                            <label for="publicYes"> UPSI Made Public</label>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-lg-3">
                                    <div class="form-group">
                                        <div class="md-radio">
                                            <input id="publicNO" type="radio"
                                                [formControl]="sharerForm.controls['PublicStatus']" class="col-lg-2"
                                                style="padding:6px;" value=" UPSI Not Applicable">
                                            <label for="publicNO">UPSI Not Applicable</label>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-lg-3"></div>
                            </div> -->
                            <br>
                            <div class="row">
                                <div class="col-lg-2">
                                    <label class="form-control-label">Date:</label>
                                </div>
                                <div class="col-lg-4">
                                    <div class="input-group" (click)="$event.stopPropagation();">
                                        <input class="form-control" [formControl]="sharerForm.controls['publicDate']"
                                            placeholder="dd-mm-yyyy" ngbDatepicker #b="ngbDatepicker"
                                            (click)="b.toggle();" (focusin)="setPublicDatePublic($event)">
                                        <button class="input-group-addon" (click)="b.toggle();" type="button">
                                            <span class="fa fa-calendar"></span>
                                        </button>                                        
                                    </div>
                                    <div *ngIf="sharerForm.controls['publicDate'].hasError('ngbDate')"
                                            class="form-control-error-custom">
                                            Public Date cannot be prior to Shared Date.
                                        </div>

                                </div>
                                <div class="col-lg-2">
                                    <label class="form-control-label">Time:</label>
                                </div>
                                <div class="col-lg-4">
                                    <div class="form-group">
                                        <label class="input-group" (focusout)="timePublic($event)">
                                            <input type="text" class="form-control timepicker-init-public"
                                                [formControl]="sharerForm.controls['publicTime']">
                                            <span class="input-group-addon">
                                                <i class="icmn-clock"></i>
                                            </span>
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-md-2" >
                            <label class="form-control-label" for="l0">Attachment (Not for Email):
                            </label>
                        </div>
                        <div class="col-md-4" >
                            <div class="form-group">
                                <label class="input-group">
                                    <input data-toggle="tooltip" type="text"
                                    [value]="(basefileNameArray.length) > 0 ? basefileNameArray.length + ' File(s) Selected':' File Not Available'"
                                        class="form-control" [disabled]="true">

                                    <!-- <span *ngIf="agenda.AgendaGenerationPdf && agenda.AgendaGenerationPdf.length > 0 && agenda.AgendaGenerationPdf[0].IsAvailable" (click)="downloadDoc(agenda.AgendaGenerationPdf[0].DocumentManagementID)"
                                                class="input-group-addon default">
                                                <i class="fa fa-download"></i>
                                            </span> -->
                                    <span class="input-group-addon warning"
                                        (click)="initiateUploadFileBase($event)"
                                       >
                                        <i class="fa fa-upload"></i>
                                    </span>

                                </label>
                                <!-- <input name="Attachment" class='form-control IsDisableEmail' type="file"
                                    (change)="fileChangedEmail($event);EmailsCheck($event);" accept=".xlsx, .xls, .csv, .jpg, .jpeg, .png, .doc, .docx, .txt, .pdf, .ppt, .mp4,.pptx">
                                <span style="color: red" *ngIf="!fileExtension">Please upload valid file format.</span> -->
                            </div>
                        </div>


                        <!--<div class="row">
                            <div class="col-lg-2">
                                <label class="form-control-label">Document Upload (Not for Email):</label>
                            </div>
                            <div class="col-lg-4 form-group" >
                                <label class="input-group">
                                    <input data-toggle="tooltip" type="text"
                                        [value]= "(fileDocArray.length+listOfDoc.length) > 0 ? listOfDoc.length + fileDocArray.length  + ' Files Selected':' File Not Available'"
                                        class="form-control" [disabled]="true">

                                    
                                    <span class="input-group-addon warning"
                                        (click)="initiateUploadFileDocument($event)"
                                       >
                                        <i class="fa fa-upload"></i>
                                    </span>

                                </label>
                                
                            </div>-->
                            <!-- <div class="col-lg-2" *ngIf="!documentId">
                                <label class="form-control-label">Document Upload (Not for Email):</label>
                            </div>
                            <div class="col-lg-4" *ngIf="!documentId">
                                <input type="file" class='form-control' (change)="fileChanged($event)" accept=".xlsx, .xls, .csv, .jpg, .jpeg, .png, .doc, .docx, .txt, .pdf, .ppt, .mp4,.pptx">
                                <span style="color: red" *ngIf="fileSizeError">File size is greater than 2MB</span>
                                <span style="color: red" *ngIf="!checkfileExtension">Please upload valid file format.</span>
                            </div>


                            <div class="col-lg-2" *ngIf="documentId">
                                <label class="form-control-label">Document Upload (Not for Email):</label>
                            </div>
                            <div class="col-lg-4" *ngIf="documentId">
                                <a class="btn btn-sm btn-default"><span
                                        (click)="downloadFile(documentId)">{{fileOriginalName}}</span>&nbsp;<span
                                        (click)="downloadFile(documentId)" style="margin-left: 10px"><i
                                            class="fa fa-download"></i></span><span (click)="deleteFile(documentId)"
                                        style="margin-left: 10px"><i class="fa fa-close"
                                            style="color: white"></i></span></a>

                            </div> -->

                        <!--</div>-->






                    </div>
                    <div class="modal-footer" *ngIf="!isEdit">
                        <span style="color: red" *ngIf="isValidSharerAndRecipient">Please select sharer or
                            Recipient</span>
                        <button class="btn btn-sm btn-primary" [disabled]="!RecipientNameArray || !sharerForm.valid || OtherNatureOfUPSIValid || disabledOnclick || !fileExtension || !checkfileExtension"
                            (click)="submit()">Submit</button>
                        <!-- <button class="btn btn-success" (click)="submit()">Submit</button> -->
                    </div>
                    <div class="modal-footer" *ngIf="isEdit">
                        <span style="color: red" *ngIf="isValidSharerAndRecipient">Please select sharer or
                            Recipient</span>
                        <button class="btn btn-sm btn-primary" [disabled]="!RecipientNameArray || !sharerForm.valid || OtherNatureOfUPSIValid || disabledOnclick"
                            (click)="update()">Update</button>
                        <!-- <button class="btn btn-success" (click)="submit()">Submit</button> -->
                    </div>
                </form>
            </div>
        </div>
    </div>

</section>
<div class="modal" id="AddModel" tabindex="-1" role="dialog" data-backdrop="static" data-keyboard="false"
    aria-labelledby="" aria-hidden="true" style="top: 50px;">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">
                    Add New</h5>
                <button aria-label="Close" class="close" data-dismiss="modal" type="button">
                    <i class="fa fa-times"></i>
                </button>

            </div>
            <div class="modal-body">
                <div class="row">
                    <div class="col-sm-12">
                        <input type="text" [(ngModel)]="item" class='form-control'>
                        <div *ngIf="disabledText" class="form-control-error-custom">
                            Please enter the Nature of UPSI.
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-footer">

                <button type="button" class="btn btn-sm btn-primary" (click)="save()">
                    Save</button>
                <button type="button" class="btn btn-sm btn-primary" data-dismiss="modal">
                    <i class="fa fa-times"></i>Cancel</button>
            </div>
        </div>
    </div>
</div>
<div class="modal fade modal-size-medium" id="upsiDetailsUploadDialog" tabindex="-1" role="dialog"
                data-backdrop="static" data-keyboard="false" aria-labelledby="" aria-hidden="true">
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title">
                                <i class="fa fa-upload"></i>
                                <span id="UpsiUploadTitle"></span>
                            </h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <i class="fa fa-times"></i>
                            </button>
                        </div>
                        <div class="modal-body">
                            <div class="col-md-12">
                                <div class="row collapse1">
                                    <span class="cat__core__title">
                                        Existing Files
                                    </span>

                                    <table class="table table-hover compact cell-border nowrap stripe"
                                        style="cursor: pointer;">
                                        <thead>
                                            <tr>

                                                <th>Filename</th>
                                                <th>Action</th>
                                            </tr>
                                        </thead>
                                        <tbody *ngIf= "fileNameArray || listOfFiles">
                                            <tr  *ngFor="let file of fileNameArray; let index = index">
                                                <td tabindex="1" style="cursor: move; width: 70%;">
                                                    {{file}}
                                                </td>
                                                <td>
                                                    <button type="button" *ngIf="isEdit" class="btn-sm btn btn-warning"
                                                       (click)="downloadFileEmail(file)">
                                                        <span class="fa fa-download"></span>
                                                    </button>
                                                    <button type="button" *ngIf="!isEdit" class="btn-sm btn btn-danger"
                                                    (click)="deleteFile()">
                                                        <span class="fa fa-close"></span>
                                                    </button>
                                                </td>
                                            </tr>
                                            <tr *ngFor="let selected of listOfFiles;let index = index">

                                                <td tabindex="1" style="cursor: move; width: 70%;">
                                                    {{selected}}
                                                </td>
                                                <td>
                                                    <button type="button" class="btn-sm btn btn-warning"
                                                    >
                                                        <span class="fa fa-download"></span>
                                                    </button>
                                                    <!-- <button type="button" class="btn-sm btn btn-warning">
                                                                <span class="fa fa-download"></span>
                                                        </button> -->

                                                    <button type="button" class="btn-sm btn btn-danger"
                                                        (click)="removeSelectedEmailFile(index)">
                                                        <span class="fa fa-close"></span>
                                                    </button>
                                                </td>
                                            </tr>
                                            
                                        </tbody>
                                    </table>
                                    <div class="row" *ngIf="!isEdit">
                                        <div class="col-md-4">
                                            <label class="col-form-label" for="l5">
                                                <span>Document Attachment
                                                    <span _ngcontent-c2="" style="color: red;">*</span>
                                                </span>
                                            </label>
                                        </div>
                                        <div class="col-md-8">
                                            <div class="form-group">
                                                
                                                <input type="file" class='form-control fileUpload'
                                                #attachments type="file" (change)="onEmailFileChanged($event)" #fileInput multiple="true"
                                                    accept=".xlsx, .xls, .csv, .jpg, .jpeg, .png, .doc, .docx, .txt, .pdf, .ppt, .mp4,.pptx"
                                                     />
                                                <!-- <span *ngIf="typeHasError" style="color: red">
                                                    Please upload valid file format.
                                                </span> -->

                                            </div>
                                            <!-- {{fileHasError | json}} -->
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                        <div class="modal-footer">

                            <button id="saveAgendaDoc" *ngIf="!isEdit" type="button" class="btn-sm btn btn-primary"
                            
                              data-dismiss="modal">
                                <i class="fa fa-save"></i>Upload</button>

                            <button type="button" class="btn-sm btn btn-default" data-dismiss="modal">
                                <i class="fa fa-times"></i>Close</button>

                        </div>
                    </div>
                </div>
</div>


<div class="modal fade modal-size-medium" id="BaseUpsiDetailsUploadDialog" tabindex="-1" role="dialog"
                data-backdrop="static" data-keyboard="false" aria-labelledby="" aria-hidden="true">
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title">
                                <i class="fa fa-upload"></i>
                                <span id="BaseUpsiUploadTitle"></span>
                            </h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <i class="fa fa-times"></i>
                            </button>
                        </div>
                        <div class="modal-body">
                            <div class="col-md-12">
                                <div class="row collapse1">
                                    <span class="cat__core__title">
                                        Existing Files
                                    </span>

                                    <table class="table table-hover compact cell-border nowrap stripe"
                                        style="cursor: pointer;">
                                        <thead>
                                            <tr>
                                                <th>Filename test</th>
                                                <th>Action</th>
                                            </tr>
                                        </thead>
                                        <tbody *ngIf= "basefileNameArray">
                                            <tr  *ngFor="let file of basefileNameArray; let index = index">
                                                <td tabindex="1" style="cursor: move; width: 70%;">
                                                    {{file.name}}
                                                </td>
                                                <td>
                                                    <button type="button" *ngIf="isEdit && file.backendName!=null" class="btn-sm btn btn-warning"
                                                       (click)="downloadFileBase(file.backendName)">
                                                        <span class="fa fa-download"></span>
                                                    </button>
                                                    <button type="button" class="btn-sm btn btn-danger"
                                                    (click)="deleteFileBase(index)">
                                                        <span class="fa fa-close"></span>
                                                    </button>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <div class="row" >
                                        <div class="col-md-4">
                                            <label class="col-form-label" for="l5">
                                                <span>Document Attachment
                                                    <span _ngcontent-c2="" style="color: red;">*</span>
                                                </span>
                                            </label>
                                        </div>
                                        <div class="col-md-8">
                                            <div class="form-group">
                                                <input type="file" class='form-control fileUpload' 
                                                    #attachments type="file" 
                                                    (change)="onEmailFileChangedBase($event)"
                                                    #fileInput multiple="true"
                                                    accept=".xlsx, .xls, .csv, .jpg, .jpeg, .png, .doc, .docx, .txt, .pdf, .ppt, .mp4,.pptx" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer">

                            <button id="saveAgendaDoc" *ngIf="!isEdit" type="button" class="btn-sm btn btn-primary"
                            
                              data-dismiss="modal">
                                <i class="fa fa-save"></i>Upload</button>

                            <button type="button" class="btn-sm btn btn-default" data-dismiss="modal">
                                <i class="fa fa-times"></i>Close</button>

                        </div>
                    </div>
                </div>
</div>

<div class="modal fade modal-size-medium" id="upsiDetailsFileUploadDialog" tabindex="-1" role="dialog"
                data-backdrop="static" data-keyboard="false" aria-labelledby="" aria-hidden="true">
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title">
                                <i class="fa fa-upload"></i>
                                <span id="UpsiFileUploadTitle"></span>
                            </h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <i class="fa fa-times"></i>
                            </button>
                        </div>
                        <div class="modal-body">
                            <div class="col-md-12">
                                <div class="row collapse1">
                                    <span class="cat__core__title">
                                        Existing Files
                                    </span>

                                    <table class="table table-hover compact cell-border nowrap stripe"
                                        style="cursor: pointer;">
                                        <thead>
                                            <tr>

                                                <th>Filename</th>
                                                <th>Action</th>
                                            </tr>
                                        </thead>
                                        <tbody *ngIf= "fileDocArray || listOfDoc">
                                            <tr  *ngFor="let file of fileDocArray; let index = index">
                                                <td tabindex="1" style="cursor: move; width: 70%;">
                                                    {{file.FileName}}
                                                </td>
                                                <td>
                                                    <button type="button" *ngIf="isEdit" class="btn-sm btn btn-warning"
                                                       (click)="downloadFile(file.DocumentId.toString())">
                                                        <span class="fa fa-download"></span>
                                                    </button>
                                                    <button type="button" class="btn-sm btn btn-danger"
                                                    (click)="deleteFile(index)">
                                                        <span class="fa fa-close"></span>
                                                    </button>
                                                </td>
                                            </tr>
                                            <tr *ngFor="let selected of listOfDoc;let index = index">

                                                <td tabindex="1" style="cursor: move; width: 70%;">
                                                    {{selected}}
                                                </td>
                                                <td>
                                                    <button type="button" class="btn-sm btn btn-warning"
                                                    >
                                                        <span class="fa fa-download"></span>
                                                    </button>
                                                

                                                    <button type="button" class="btn-sm btn btn-danger"
                                                        (click)="removeSelectedDocFile(index)">
                                                        <span class="fa fa-close"></span>
                                                    </button>
                                                </td>
                                            </tr>
                                            
                                        </tbody>
                                    </table>
                                    <div class="row">
                                        <div class="col-md-4">
                                            <label class="col-form-label" for="l5">
                                                <span>Document Attachment
                                                    <span _ngcontent-c2="" style="color: red;">*</span>
                                                </span>
                                            </label>
                                        </div>
                                        <div class="col-md-8">
                                            <div class="form-group">
                                                
                                                <input type="file" class='form-control fileUpload'
                                                #attachments type="file" (change)="onDocumentFileChanged($event)" #fileInput multiple="true"
                                                    accept=".xlsx, .xls, .csv, .jpg, .jpeg, .png, .doc, .docx, .txt, .pdf, .ppt, .mp4,.pptx"
                                                     />
                                                <!-- <span *ngIf="typeHasError" style="color: red">
                                                    Please upload valid file format.
                                                </span> -->

                                            </div>
                                            <!-- {{fileHasError | json}} -->
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                        <div class="modal-footer">

                            <button id="saveAgendaDoc"  type="button" class="btn-sm btn btn-primary"
                            
                              data-dismiss="modal">
                                <i class="fa fa-save"></i>Upload</button>

                            <button type="button" class="btn-sm btn btn-default" data-dismiss="modal">
                                <i class="fa fa-times"></i>Close</button>

                        </div>
                    </div>
                </div>
</div>
<app-alert></app-alert>